export const selectFile = (fileId: number) => (state: Store.State) => state.files.values[fileId];
export const selectGetFile = (state: Store.State) => (fileId: number) => state.files.values[fileId];

export const selectFileValues = (state: Store.State) => state.files.values;
export const selectFileIds = (state: Store.State) => state.files.ids;